export interface EvaluableTeacher {
  readonly id: string;
  readonly name: string;
  readonly gender: 'f' | 'm';
  readonly pictureUrl: string;
  readonly prefectures: string;
}

export interface RatingTag {
  readonly name: string;
  readonly selected: boolean;
  readonly icon: string;
}

export interface TeacherNotations {
  readonly general: number;
  readonly punctuality: number;
  readonly pedagogy: number;
  readonly communication: number;
}

export interface TeacherRatingRequest {
  readonly selectedTeacherId: string;
  readonly teacherNotations: TeacherNotations;
  readonly publicComment: string;
  readonly anonymousComment: boolean;
  readonly privateComment: string;
}

export interface RatingSubmissionRequest {
  readonly lessonId: string;
  readonly rate: number;
  readonly comment: string;
  readonly anonymousShare: boolean;
  readonly tags: string[];
}

export interface RatingSubmissionResponse {
  readonly lessonId: string;
  readonly rate: number;
  readonly comment: string;
  readonly anonymousShare: boolean;
  readonly tags: string[];
}

const TAG_ICON_MAP: Record<string, string> = {
  Encourageant: 'TrophyCup',
  Pédagogue: 'SchoolBag',
  Ponctuel: 'Clock',
  Sympathique: 'Heart',
};

export class RatingMapper {
  static toTags(res: any): RatingTag[] {
    return res.data.map((tag: any) => ({
      name: tag.name,
      selected: false,
      icon: TAG_ICON_MAP[tag.name] ?? '',
    }));
  }

  static toPayload(req: RatingSubmissionRequest) {
    return {
      lesson_id: req.lessonId,
      rate: req.rate,
      comment: req.comment,
      anonymous_share: req.anonymousShare,
      tags: req.tags,
    };
  }

  static toTeacherRatingPayload(req: TeacherRatingRequest) {
    return {
      teacher_rating: {
        teacher_id: req.selectedTeacherId,
        global_rate: req.teacherNotations.general,
        public_comment: req.publicComment,
        private_comment: req.privateComment,
        anonymous: req.anonymousComment,
        rating_type: 'end_of_course_rating',
        rate_by_category: {
          pedagogy: req.teacherNotations.pedagogy,
          punctuality: req.teacherNotations.punctuality,
          communication: req.teacherNotations.communication,
        },
      },
    };
  }

  static toEvaluableTeachers(res: any): EvaluableTeacher[] {
    return res.data.teachers.map((teacher: any) => ({
      id: teacher.id,
      name: `${teacher.first_name} ${teacher.last_name.charAt(0)}.`,
      pictureUrl: teacher.picture_url,
      prefectures: teacher.prefectures,
      gender: teacher.gender,
    }));
  }

  static toResponse(res: any): RatingSubmissionResponse {
    return {
      lessonId: res.lesson_id,
      rate: res.rate,
      comment: res.comment,
      anonymousShare: res.anonymous_share,
      tags: res.tags,
    };
  }
}
